// HorizontalSubMenuComponent.jsx
import React from 'react';
import EditableTable from "./EditableTable";
import UploadCsv from "./UploadCsv";

const TABS = [
	{id: 0, label: 'All contacts'},
	{id: 1, label: 'Upload CSV'},
];

const HorizontalSubMenuComponent = ({
	userContacts,
	isLoading,
	activeTab,
	setActiveTab,
	addRowSignal,
	onAddContact,
	onSwitchToUpload,
	refetchContacts,
}) => {
	return (
		<div>
			<div className="flex items-center gap-6 border-b border-slate-200 mb-5">
				{TABS.map(({id, label}) => {
					const active = activeTab === id;
					return (
						<button
							key={id}
							type="button"
							onClick={() => setActiveTab(id)}
							className={
								'relative -mb-px py-3 text-sm font-medium transition-colors ' +
								(active
									? 'text-slate-900 border-b-2 border-emerald-500'
									: 'text-slate-500 hover:text-slate-800 border-b-2 border-transparent')
							}>
							{label}
						</button>
					);
				})}
			</div>

			<div>
				{activeTab === 0 ? (
					<EditableTable
						initialData={userContacts}
						isLoading={isLoading}
						addRowSignal={addRowSignal}
						onAddContact={onAddContact}
						onSwitchToUpload={onSwitchToUpload}
						refetchContacts={refetchContacts}
					/>
				) : (
					<UploadCsv userContacts={userContacts}/>
				)}
			</div>
		</div>
	);
};

export default HorizontalSubMenuComponent;
